import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import ClientSidebar from './ClientSidebar';
import { useAuth } from '../../contexts/AuthContext';
import { ClientSettingsProvider } from '../../contexts/ClientSettingsContext';

const ClientLayout = () => {
  const { isClientAuthenticated, clientLoading, clientUser } = useAuth();

  // Show loading while checking authentication
  if (clientLoading) {
    return (
      <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-2 border-teal-400 border-t-transparent rounded-full animate-spin"></div>
          <div className="text-teal-400">Loading...</div>
        </div>
      </div>
    );
  }

  // Only redirect to login if NOT loading AND NOT authenticated
  if (!isClientAuthenticated) {
    return <Navigate to="/client" replace />;
  }

  return (
    <ClientSettingsProvider clientId={clientUser?.id}>
      <div className="min-h-screen bg-[#0a0a0f] flex">
        <ClientSidebar />
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </ClientSettingsProvider>
  );
};

export default ClientLayout;
